var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class AggregatesGamesBlockState {
    constructor(provider) {
        this.provider = provider;
        this.gameData = {};
    }
    activate() {
        this.provider.on(InternalMessageBusChannels.aggregatedEvents.games.update, this.updateGameData);
        this.provider.emit(InternalMessageBusChannels.aggregatedEvents.games.request);
    }
    deactivate() {
        this.provider.off(InternalMessageBusChannels.aggregatedEvents.games.update, this.updateGameData);
        this.clearData();
    }
    updateGameData(message) {
        if (message.data[0] && message.data[0].games) {
            this.gameData = message.data[0].games;
        }
    }
    clearData() {
        this.gameData = {};
    }
    get isDataLoaded() {
        return this.gameData.aggregatedParticipants1 != undefined;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesGamesBlockState.prototype, "gameData", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatesGamesBlockState.prototype, "updateGameData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesGamesBlockState.prototype, "clearData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AggregatesGamesBlockState.prototype, "isDataLoaded", null);
//# sourceMappingURL=AggregatesGamesBlockState.js.map